import type { ICellRendererParams } from 'ag-grid-community'
import React from 'react'
import type { AttendancePlayer } from '../../types'
import { isWaiverLocked } from '@sportninja/common/features/game/attendance/utils/waiverLock'
import {
  getPlayerDisplayName,
  isJerseyConflict,
} from '../../utils/attendanceRowState'
import { getJerseyConflictNames } from '../../utils/jerseyConflict'
import AttendanceJerseyCell from '../AttendanceJerseyCell'
import { useAttendanceSection } from './AttendanceSectionContext'

/** `#` column: the editable jersey number box. */
const JerseyCell = ({ data }: ICellRendererParams<AttendancePlayer>) => {
  const {
    waiverEnforced,
    requireUniqueJerseyNumbers,
    duplicateJerseyNumbers,
    isSpareCandidate,
    allPlayers,
    onUpdatePlayerNumber,
  } = useAttendanceSection()

  if (!data) {
    return null
  }

  const isConflict = isJerseyConflict(
    data,
    requireUniqueJerseyNumbers,
    duplicateJerseyNumbers
  )

  return (
    <AttendanceJerseyCell
      playerId={data.id}
      playerName={getPlayerDisplayName(data)}
      playerNumber={data.player_number}
      isConflict={isConflict}
      conflictNames={isConflict ? getJerseyConflictNames(data, allPlayers) : []}
      isSuspended={!!data.is_suspended}
      isWaiverLocked={isWaiverLocked(data, waiverEnforced, isSpareCandidate)}
      onUpdatePlayerNumber={onUpdatePlayerNumber}
    />
  )
}

export default JerseyCell
